import { Link } from "react-router-dom";

export const Logo = ({ dark = false, className = "h-11 w-11" }) => (
  <Link
    to="/"
    data-testid="brand-logo-link"
    className="flex items-center gap-3"
    aria-label="Rooted Healing, back to home"
  >
    <span
      className={`flex items-center justify-center rounded-full ${dark ? "bg-ivory/95 p-1 shadow-[0_4px_14px_rgba(0,0,0,0.25)]" : ""}`}
    >
      <img
        src="/images/rooted-healing-logo.png"
        alt="Rooted Healing tree of life emblem"
        className={className}
        width="1254"
        height="1254"
      />
    </span>
    <span className="leading-none">
      <span className={`block font-serif text-xl tracking-tight ${dark ? "text-ivory" : "text-forest"}`}>
        Rooted Healing
      </span>
      <span className={`block text-[11px] uppercase tracking-[0.3em] mt-1 ${dark ? "text-ivory/60" : "text-taupe"}`}>
        by Staci Freed
      </span>
    </span>
  </Link>
);
